export default __webpack_public_path__ + "static/media/19.96ac34cc.webp";